import { Fragment, useState } from 'react'
import { Transition } from '@headlessui/react'
import { CheckCircleIcon } from '@heroicons/react/24/outline'
import { XMarkIcon } from '@heroicons/react/20/solid'

export default function NoVideoEmbed() {
  const [ showVideo, setShowVideo ] = useState(true)
  const [ showReminder, setShowReminder ] = useState(false)
  
  return (
    <>
      {/* Global notification live region, render this permanently at the end of the document */}
      <div
        aria-live="assertive"
        className="pointer-events-none fixed inset-x-0 flex items-end px-4 py-6 sm:items-start sm:p-6 bottom-4 right-4"
      >
        <div className="flex w-full flex-col items-center space-y-4 sm:items-end">
          {/* Notification panel, dynamically insert this into the live region when it needs to be displayed */}
          <Transition
            show={showReminder}
            as={Fragment}
            enter="transform ease-out duration-300 transition"
            enterFrom="translate-y-2 opacity-0 sm:translate-y-0 sm:translate-x-2"
            enterTo="translate-y-0 opacity-100 sm:translate-x-0"
            leave="transition ease-in duration-100"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
            afterLeave={() => setShowVideo(true)}
          >
            <div className="pointer-events-auto">
              <span
                onClick={() => setShowReminder(false)}
                className="inline-flex items-center rounded-full bg-pinto px-2.5 py-0.5 text-xs font-medium text-white cursor-pointer">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="-ml-0.5 mr-1.5 w-2 h-2 text-white">
                  <path strokeLinecap="round" strokeLinejoin="round" d="M19.5 19.5l-15-15m0 0v11.25m0-11.25h11.25" />
                </svg>

                View Report Review
              </span>
            </div>
          </Transition>
          <Transition
            show={showVideo}
            afterLeave={() => setShowReminder(true)}
            as={Fragment}
            enter="transform ease-out duration-300 transition"
            enterFrom="translate-y-2 opacity-0 sm:translate-y-0 sm:translate-x-2"
            enterTo="translate-y-0 opacity-100 sm:translate-x-0"
            leave="transition ease-in duration-100"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
              <div className="pointer-events-auto w-full max-w-sm overflow-hidden rounded-lg bg-white shadow-lg ring-1 ring-black ring-opacity-5">
              <div className="p-4">
                <div className="flex items-start">
                  <div className="ml-3 w-0 flex-1 pt-0.5">
                    {/* <p className="text-sm font-medium text-gray-900">Your Report Review</p> */}
                    <div className="inset-0 flex items-center justify-center z-50">
                      <div>
                        <div className="">
                          <h2 className="text-2xl tracking-tight text-pinto-dark sm:text-2xl">Video review coming</h2>
                          <p className="text-sm leading-6 text-gray-900 text-left font-semibold mt-2">Your video review is on it&apos;s way. Sit tight and we&apos;ll have it to you shortly.</p>
                        </div>
                        
                        <div className="mt-4 mb-2 flex justify-start">
                          <button
                            onClick={() => {
                              setShowVideo(false)
                            }}
                            className={`rounded-md bg-pinto px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-pinto-dark focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-pinto-dark transition-all duration-500`}
                          >
                            Close
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="ml-4 flex flex-shrink-0">
                  {/*<div className="absolute -right-2">*/}
                    <button
                      type="button"
                      className="inline-flex rounded-md bg-white text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
                      onClick={() => {
                        setShowVideo(false)
                      }}
                    >
                      <span className="sr-only">Close</span>
                      <XMarkIcon className="h-5 w-5" aria-hidden="true" />
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </Transition>
        </div>
      </div>
    </>
  )
}
